$(() => {
  $.fn.membershipPurchase = function Plugin(options) {
    const defaults = {
      questionsUrls: [],
    };
    const settings = $.extend({}, defaults, options);
    const $form = $(this);
    const $snackBar = $('[data-js-snack-bar]');

    /**
     * Pick a package and then ask the server if there are any questions to be asked
     * @param event
     */
    const selectPackage = (event) => {
      const $package = $(event.currentTarget);
      const $club = $package.closest('[data-js-club]');
      const $questionSection = $club.find('[data-js-questions]');
      const $packageSpinner = $club.find('[data-js-package-spinner-container]');

      $packageSpinner.removeClass('hidden');
      $questionSection.addClass('hidden');

      $.ajax({
        type: 'GET',
        url: settings.questionsUrls[$package.data('registrant-id')],
        data: {
          clubId: $package.data('club-id'),
          packageId: $package.val(),
          registrantId: $package.data('registrant-id'),
        },
      })
        .always(() => {
          $packageSpinner.addClass('hidden');
        })
        .done((response) => {
          $questionSection
            .toggleClass('hidden', response.data.html.length <= 0)
            .html(response.data.html);
        })
        .fail((response) => {
          $snackBar.snackBar('add', {
            type: 'danger',
            icon: 'exclamation-circle',
            content: response.responseText,
          });
        });
    };

    /**
     * Tell the server about our intent to purchase memberships
     * @param event
     */
    const submit = (event) => {
      if (!$form[0].checkValidity()) {
        return;
      }

      event.preventDefault();

      $.ajax({
        url: $form.attr('action'),
        type: 'post',
        data: $form.serialize(),
      })
        .done((response) => window.location.assign(response.redirect))
        .fail((response) => {
          $form.trigger('raceRoster.preventDoubleSubmission.reEnable');
          $snackBar.snackBar('add', {
            type: 'danger',
            icon: 'exclamation-circle',
            content: response.responseText,
          });
        });
    };

    /**
     * A hack to make sure that at least one of the required checkboxes has been checked
     * @param event
     */
    const requiredCheckbox = (event) => {
      const $fieldset = $(event.currentTarget).closest('fieldset');
      const $checkboxes = $fieldset.find('[type="checkbox"][data-required]');
      const $checked = $checkboxes.filter(':checked');

      $checkboxes.prop('required', !$checked.length);
    };

    /**
     * Initialize
     */
    const initialize = () => {
      $form.on('click', '[data-js-package]', selectPackage);
      $form.on('submit', submit);
      $form.on('change', '[type="checkbox"][data-required]', requiredCheckbox);
    };

    return $form.each(initialize);
  };
});
